<template>
  <StudioDialog :title="videoAsset.name" size="large" @close="$emit('close')">
    <div class="tw-flex tw-h-full tw-items-center tw-justify-center tw-px-4">
      <HlsPlayer class="play-video-body" :videoStreamUrl="videoAsset.urls?.hls" />
    </div>
  </StudioDialog>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

import HlsPlayer from './HlsPlayer.vue';
import { VideoAsset } from './videoLibraryService';

import StudioDialog from '@/studioComponents/StudioDialog.vue';

export default defineComponent({
  name: 'HLSVideoPreviewDialog',
  components: {
    StudioDialog,
    HlsPlayer
  },
  props: {
    videoAsset: {
      type: Object as PropType<VideoAsset>,
      required: true
    }
  }
});
</script>
